import buildSizesString, { SizesType, BaseSizeProps } from './buildSizesString';

export type { SizesType, BaseSizeProps };
export default buildSizesString;
